import type {
  CreateUpstreamModelMappingRequest,
  CreateUpstreamModelMappingResponse,
  DeleteUpstreamModelMappingResponse,
  ListUpstreamModelMappingsResponse,
  UpdateUpstreamModelMappingRequest,
  UpdateUpstreamModelMappingResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

export function listModelMappings(
  upstreamId: string,
  fetchImpl: typeof fetch = fetch,
): Promise<ListUpstreamModelMappingsResponse> {
  return opsApiRequest<ListUpstreamModelMappingsResponse>(
    `/v1/ops/upstreams/${upstreamId}/model-mappings`,
    { method: 'GET' },
    fetchImpl,
  );
}

export function createModelMapping(
  upstreamId: string,
  body: CreateUpstreamModelMappingRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<CreateUpstreamModelMappingResponse> {
  return opsApiRequest<CreateUpstreamModelMappingResponse>(
    `/v1/ops/upstreams/${upstreamId}/model-mappings`,
    { method: 'POST', headers: { 'content-type': 'application/json' }, body },
    fetchImpl,
  );
}

export function deleteModelMapping(
  upstreamId: string,
  vendor: string,
  channel: string,
  model: string,
  protocol: string,
  fetchImpl: typeof fetch = fetch,
): Promise<DeleteUpstreamModelMappingResponse> {
  return opsApiRequest<DeleteUpstreamModelMappingResponse>(
    `/v1/ops/upstreams/${upstreamId}/model-mappings/${vendor}/${channel}/${model}/${protocol}`,
    { method: 'DELETE' },
    fetchImpl,
  );
}

export function updateModelMapping(
  upstreamId: string,
  vendor: string,
  channel: string,
  model: string,
  protocol: string,
  body: UpdateUpstreamModelMappingRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<UpdateUpstreamModelMappingResponse> {
  return opsApiRequest<UpdateUpstreamModelMappingResponse>(
    `/v1/ops/upstreams/${upstreamId}/model-mappings/${vendor}/${channel}/${model}/${protocol}`,
    { method: 'PATCH', headers: { 'content-type': 'application/json' }, body },
    fetchImpl,
  );
}
